export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}
function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

export function getDays (strDateStart, strDateEnd) {
  var strSeparator = '-'
  var oDate1
  var oDate2
  var iDays
  oDate1 = strDateStart.split(strSeparator)
  oDate2 = strDateEnd.split(strSeparator)
  var strDateS = new Date(oDate1[0], oDate1[1] - 1, oDate1[2])
  var strDateE = new Date(oDate2[0], oDate2[1] - 1, oDate2[2])
  iDays = parseInt(Math.abs(strDateS - strDateE) / 1000 / 60 / 60 / 24)
  return iDays
}



// WEBPACK FOOTER //
// ./src/utils/dateUtil.js